import React from "react";
import { Container, Table } from "reactstrap";
import { convertCurrency } from "../../../../../utility/Utils";
import styles from "../SalesTables.module.scss";

const SalesByProduct = () => {
  const data = [
    { product: "Product 1", totalSales: 10000, aov: 7000, ordersPlaced: 115 },
    { product: "Product 2", totalSales: 9000, aov: 7000, ordersPlaced: 115 },
    { product: "Product 3", totalSales: 9000, aov: 7000, ordersPlaced: 115 },
    { product: "Product 4", totalSales: 8000, aov: 7000, ordersPlaced: 115 },
  ];

  return (
    <Container fluid className={styles.mainContainer}>
      <h5 className="my-3">Sales by Product</h5>

      <Table responsive className={styles.table}>
        <thead>
          <tr>
            <th>Product</th>
            <th>Total Sales</th>
            <th>AOV</th>
            <th>Orders Placed</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr>
              <td>{item.product}</td>
              <td>${convertCurrency(item.totalSales)}</td>
              <td>${convertCurrency(item.aov)}</td>
              <td>{item.ordersPlaced}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default SalesByProduct;